export default "__VITE_ASSET__1lYS$eUi__"